var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShapeLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 14,
    viewBox: "0 0 9 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.80157 10.927L7.802 10.9274C8.05627 11.1764 8.2 11.5144 8.2 11.8678C8.2 12.2213 8.05627 12.5593 7.802 12.8083L7.66207 12.6654L7.80216 12.8081C7.67529 12.9326 7.52465 13.0312 7.35905 13.0983C7.19346 13.1655 7.01604 13.2 6.83696 13.2C6.65789 13.2 6.48046 13.1655 6.31488 13.0983C6.14943 13.0312 5.9989 12.9328 5.8721 12.8084C5.87199 12.8083 5.87188 12.8082 5.87177 12.8081L0.945575 8.01267C0.945444 8.01254 0.945313 8.01241 0.945182 8.01229C0.817456 7.88887 0.715769 7.74178 0.646247 7.57933C0.576649 7.41671 0.540741 7.24209 0.540741 7.06558C0.540741 6.88908 0.576649 6.71445 0.646247 6.55183C0.715701 6.38955 0.817259 6.24259 0.94481 6.11924C0.945065 6.11899 0.945319 6.11875 0.945575 6.1185L5.87152 1.26674L5.87177 1.26649C5.99864 1.14198 6.14928 1.04343 6.31488 0.976268C6.48046 0.909113 6.65789 0.874601 6.83696 0.874601C7.01604 0.874601 7.19347 0.909113 7.35905 0.976268C7.52465 1.04343 7.67529 1.14198 7.80216 1.26649C8.05633 1.51548 8.2 1.8534 8.2 2.20678C8.2 2.56012 8.05636 2.898 7.80225 3.14697C7.80216 3.14706 7.80208 3.14714 7.802 3.14722L3.83387 7.06458L7.80157 10.927Z",
    fill: "#32193A",
    stroke: "#32193A",
    strokeWidth: 0.4
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShapeLeft);
export default __webpack_public_path__ + "static/media/ShapeLeft.37cc2660e3680d23861643d7a46a91c1.svg";
export { ForwardRef as ReactComponent };